import React from 'react';

import { Box, Typography } from '@mui/material';

import currencyFormatter from '~/utils/currencyFormatter';

import { SurchargeSuggestionBQ } from '../types';

export default function StatisticsFormatter({ row }: { row: SurchargeSuggestionBQ }) {
  return (
    <Box>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Current Vendor Surcharge:
        </Typography>{' '}
        {currencyFormatter('AUD', row.vendor_surcharge_total, 2)}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Current Internal Surcharge:
        </Typography>{' '}
        {currencyFormatter('AUD', row.internal_surcharge_total, 2)}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Current Base Nightly Price:
        </Typography>{' '}
        {currencyFormatter('AUD', row.nightly_price_aud, 2)}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Current Nightly Price:
        </Typography>{' '}
        {currencyFormatter('AUD', row.before_price, 2)}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Suggested Nightly Price:
        </Typography>{' '}
        {currencyFormatter('AUD', row.suggested_after_price, 2)}
      </Typography>
    </Box>
  );
}
